import type { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { createContext } from 'react';

export type AuthContextType = {
  authState: AuthState | null;
  oktaAuth: OktaAuth | null;
};

export const AuthContext = createContext<AuthContextType>({ authState: null, oktaAuth: null });
